//
import { API } from "../../api";
async function create_basket(request) {
    // console.log("create_basket -> request", request);
    return await new API().apiPost({
        baseUrl: process.env.LETS_TRADE_BASKET_URL ?? "",
        endpoint: `v2/create`,
        content: request,
    });
}
export { 
// ICreateBasketRequest,
create_basket, };
